module.exports = __webpack_public_path__ + "img/weather_app_mockup.e28e836a.png";